// removed by extract-text-webpack-plugin
module.exports = {"rewardsCard":"rewardsCard___3Dw85"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpRewardsCard.module.less
// module id = 3313
// module chunks = 33